<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Bubble Charts"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Basic Bubble Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="simpleBubbleChart.series"
					[chart]="simpleBubbleChart.chart"
					[xaxis]="simpleBubbleChart.xaxis"
					[fill]="simpleBubbleChart.fill"
					[dataLabels]="simpleBubbleChart.dataLabels"
					[title]="simpleBubbleChart.title"
					[yaxis]="simpleBubbleChart.yaxis"
					[colors]="simpleBubbleChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">3D Bubble Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="BubbleChart.series"
					[chart]="BubbleChart.chart"
					[xaxis]="BubbleChart.xaxis"
					[fill]="BubbleChart.fill"
					[dataLabels]="BubbleChart.dataLabels"
					[title]="BubbleChart.title"
					[yaxis]="BubbleChart.yaxis"
					[tooltip]="BubbleChart.tooltip"
					[theme]="BubbleChart.theme"
					[colors]="BubbleChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->
